<template>
  <step-item-wrapper @stepManagerState="setFrom">
    <button @click="setUserLocation()" class="btn btn-primary" type="button">ثبت موقعیت مکانی</button>
  </step-item-wrapper>
</template>

<script>
import StepItemWrapper from "../../../StepItemWrapper.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "StepManagerFormIsDigital",
  components: {StepItemWrapper},
  data() {
    return {
      form: {},
    }
  },
  computed: {
    formType() {
      return this.form.formType
    },
  },
  methods: {
    setFrom(value) {
      this.form = value
    },
    setUserLocation() {
      if (this.formType === 'product') {

        if (navigator.geolocation) {

          navigator.geolocation.getCurrentPosition(async (position) => {
            let latitude = position.coords.latitude;
            let longitude = position.coords.longitude;


            let googleLink = `https://www.google.com/maps?q=${latitude},${longitude}`
            this.form.description += `\n <a href="${googleLink}">موقعیت مکانی</a>\n`

          }, (error) => {
            toast('مکان شما در دسترس نمیباشد', 'مکان شما در دسترس نمیباشد', 'danger')
          });
        } else {
          toast('موقعیت مکانی در دستگاه شما پشتیبانی نمیشود.', 'موقعیت مکانی در دستگاه شما پشتیبانی نمیشود.', 'danger')
        }


      }
    }
  }
}
</script>

<style scoped>

</style>